var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{staticClass:"close-button",on:{"tap":_vm.action}},[_c('div',{staticClass:"cross"},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})]),_c('span',{staticClass:"text"},[_vm._v("close")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f831626","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/controls/close-button.vue
// module id = 624
// module chunks = 0